import React, { useEffect, useState } from 'react';
import AppContext from '../AppContext';
import { Redirect } from 'react-router-dom';
import { Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PaddedGrid from '../components/PaddedGrid';
import APIService from '../services/APIService';
import Loading from '../components/Loading';
import Delete from '@material-ui/icons/Delete';

const FoodServiceCategories = () => {
    const { t } = useTranslation();
    const [foodServiceCategories, setFoodServiceCategories] = useState([]);
    const [name, setName] = useState('');
    const [nameEn, setNameEn] = useState('');
    const [errors, setErrors] = useState({ name: [], name_en: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        APIService.getFoodServiceCategories().then((res) => {
            setFoodServiceCategories(res);
            setLoading(false);
        }).catch((error) => {
            AppContext.toast(`${t('Tapahtui odottamaton virhe')}, ` + error);
            setLoading(false);
        });
    }, []);

    const handleSave = () => {
        APIService.storeFoodServiceCategory({ name, name_en: nameEn }).then((res) => {
            setFoodServiceCategories(prevState => [...prevState, res]);
            setName('');
            setNameEn('');
        }).catch((error) => {
            if (error.message) {
                AppContext.toast(`${t('Tapahtui odottamaton virhe')}, ` + error.message)
            } else {
                setErrors(prevState => ({
                    ...prevState,
                    ...error.errors,
                }));
            }
        });
    };

    const handleDelete = (serviceId) => {
        APIService.deleteFoodServiceCategory(serviceId).then((res) => {
            const filtered = foodServiceCategories.filter((service) => service.id !== res.id);
            setFoodServiceCategories(filtered);
        }).catch(() => {
            AppContext.toast(t('Tapahtui odottamaton virhe'));
        });
    }

    if (!AppContext.isAdmin()) {
        return (<Redirect to="/" />);
    }

    if (loading) {
        return <Loading />;
    }

    return (
        <PaddedGrid>
            <Grid item xs={12}>
                <Typography variant="title">{t('Ravintolatyypit')}</Typography>
            </Grid>
            <Grid item xs={6}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('Suomeksi')}</TableCell>
                            <TableCell>{t('Englanniksi')}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {foodServiceCategories.map((service, i) => (
                            <TableRow key={`${service.name}-${service.name_en}`}>
                                <TableCell>{service.name}</TableCell>
                                <TableCell>{service.name_en}</TableCell>
                                <TableCell style={{ textAlign: 'right' }}>
                                    <Delete onClick={() => AppContext.prompt(() => handleDelete(service.id))} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Typography variant="subheading" style={{ marginTop: "2rem" }}>{t('Lisää uusi ravintolatyyppi')}</Typography>
                <Grid container spacing={24} >
                    <Grid item xs={4}>
                        <TextField
                            style={{ width: "100%" }}
                            label={t('Suomeksi')}
                            value={name}
                            error={!!errors['name'].length}
                            onChange={(event) => {
                                setErrors(prevState => ({
                                    ...prevState,
                                    name: [],
                                }));
                                setName(event.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            style={{ width: "100%" }}
                            label={t('Englanniksi')}
                            value={nameEn}
                            error={!!errors['name_en'].length}
                            onChange={(event) => {
                                setErrors(prevState => ({
                                    ...prevState,
                                    name_en: [],
                                }));
                                setNameEn(event.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={handleSave}
                        >
                            {t('Lisää')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </PaddedGrid>
    );
};

export default (FoodServiceCategories);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/FoodServiceCategories.js